import { APIGet, APIPost, APIPut, APIDelete, APIUrl, AdminType, StatusCode } from "api/protocols";
import { CancelToken } from "axios";
import { TCustomerType } from "redux/reducers/models/facility";
import { IBookingCategory } from "redux/reducers/models/teetime";

export type TGetCustomerType = {
  id?: number;
  default?: boolean;
  application?: string;
  /** Search customer type title or subtitle */
  search?: string;
  configuration?: boolean;
  booking_category?: boolean;
  limit?: number;
  discounts?: boolean;
};

  export type TPutCustomerTypeConfig = {
  id: string | number;
  booking_category_id: string | number | null;
  days_in_advance_start: string;
  days_in_advance_end: string;
  open_time?: string | null;
  bypass_credit_card_required?: boolean;
  max_current_bookings?: number | null;
  max_daily_bookings?: number | null;
  maximum_booking_size?: number | null;
};

interface IPostCustomerType {
  title?: string;
  migrate_customer_type_id?: number;
  subtitle?: string;
  application?: string;
  configuration?: boolean;
  booking_category_id?: number;
  default_booking_category_id?: number;
  days_in_advance_start?: number;
  days_in_advance_end?: number;
  default?: boolean;
  guest_customer_type_id?: number;
  discount_ids?: number[];
}

interface IPutCustomerType {
  title?: string;
  subtitle?: string;
  booking_category_id?: number;
  default_booking_category_id?: number;
  color?: string;
  discount_ids?: number[];
  guest_customer_type_id?: number;
  default?: boolean;
}

interface IDeleteCustomerType {
  id: number;
  migrate_customer_type_id?: number;
}

export interface ICustomerTypeRes {
  status: StatusCode;
  data: CustomerTypeResStructure[];
}

export type CustomerTypeResStructure = {
  application: string;
  booking_category: IBookingCategory;
  client_id: number;
  color: string | null;
  default: number;
  default_booking_category: IBookingCategory;
  default_booking_category_id: number;
  full_title: string;
  id: number;
  subtitle: string | null;
  title: string;
};

export async function GetCustomerType(params: TGetCustomerType, useGlobalLoader: boolean, cancelToken?: CancelToken) {
  return await APIGet<TCustomerType[]>(
    APIUrl(AdminType.FacilityAdmin, "/customer/type"),
    params,
    useGlobalLoader,
    cancelToken,
  );
}

export type TCustomerTypeCount = {
  id: number;
  customer_collects_count: number;
  cart_customer_collects_count: number;
};

export async function GetCustomerTypeCounts(useGlobalLoader: boolean, cancelToken?: CancelToken) {
  return await APIGet<TCustomerTypeCount[]>(
    APIUrl(AdminType.FacilityAdmin, "/customer/type/counts"),
    {},
    useGlobalLoader,
    cancelToken,
  );
}

export type TPostCustomerTypeConfig = {
  customer_type_ids: number[];
  booking_category_id?: string | number | null;
  days_in_advance_start?: string | number | null;
  days_in_advance_end?: string | number | null;
  open_time?: string | null;
  bypass_credit_card_required?: boolean;
  max_current_bookings?: number | null;
  max_daily_bookings?: number | null;
  maximum_booking_size?: number | null;
};

export async function PutCustomerTypeConfiguration(
  params: { configurations: TPutCustomerTypeConfig[] },
  useGlobalLoader?: boolean,
) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/customer/type/configuration"), params, useGlobalLoader);
}

export async function PostCustomerTypeConfiguration(params: TPostCustomerTypeConfig, useGlobalLoader?: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/customer/type/configuration"), params, useGlobalLoader);
}

//Post new customer type
export async function PostCustomerType(
  params: IPostCustomerType,
  useGlobalLoader?: boolean,
): Promise<ICustomerTypeRes> {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/customer/type"), params, useGlobalLoader);
}

//Edit existing customer type
export async function PutCustomerType(params: IPutCustomerType, useGlobalLoader?: boolean): Promise<ICustomerTypeRes> {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/customer/type"), params, useGlobalLoader);
}

//Delete and migrate customer type
export async function DeleteCustomerType(
  params: IDeleteCustomerType,
  useGlobalLoader?: boolean,
): Promise<ICustomerTypeRes> {
  return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/customer/type"), params, useGlobalLoader);
}

export interface IPostWelcomeEmail {
  customer_type_ids: Array<number>;
}

export async function PostWelcomeEmail(
  params: IPostWelcomeEmail,
  useGlobalLoader?: boolean,
): Promise<ICustomerTypeRes> {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/customer/type/email"), params, useGlobalLoader);
}
